module.exports = __webpack_public_path__ + "img/wenzi1.20895780.svg";